import React from 'react';
import PropTypes from 'prop-types';

const ConcentrationsCTA = ({ ctaConfig }) => {

  function createMarkup() {
    return {__html: ctaConfig.description};
  }

  return (
    <aside className="station-map-concentrations__container">
      <div className="nsw-section nsw-section--top">
        <div className="nsw-callout nsw-callout--border-none">
          <div className="nsw-callout__content">
            <h4 className="nsw-callout__title">{ctaConfig.title}</h4>
            <p dangerouslySetInnerHTML={ createMarkup() } />
            <a href={ctaConfig.link} className="nsw-text-link nsw-button nsw-button--primary">
              {ctaConfig.linkLabel}
            </a>
          </div>
        </div>
      </div>
    </aside>
  );
};

ConcentrationsCTA.propTypes = {
  "ctaConfig": PropTypes.object
};

export default ConcentrationsCTA;